<template>
  <div>
    <el-dialog
      class="category-dialog"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="category-dialog-body">
        <div class="category-dialog-main-title">
          {{title}}
        </div>
      </div>

      <div>
        <div class="panel">
          <div class="category-info">
            <div>
              <el-form ref="categoryForm" :inline="true" :rules="categoryRules" :model="category" label-width="150px" label-position="left">
                <el-form-item label="カテゴリ名称" class="master-start" prop="categoryName">
                  <el-input v-model="category.categoryName" maxlength="20" show-word-limit placeholder="カテゴリ名称" />
                </el-form-item>
              </el-form>
            </div>
          </div>

          <hr class="hr-delimiter" />

          <div style="display: flex;">
            <div style="width: 20%;">
              <span style="margin-top: 11.5px;margin-bottom: 11.5px;">子カテゴリ<span class="must_star">*</span></span>
            </div>
            <div :class="haveScroll ? 'sub-category-list' : 'sub-category-list-no-scroll'" ref="scrollContainer">
              <el-form ref="subCategoryFrom" :model="category">
                <el-table class="table-sub-category" :data="category.subCategoryList">
                  <el-table-column prop="subCategoryName" v-slot="slot">
                    <el-form-item :prop="`subCategoryList.${slot.$index}.subCategoryName`" :rules="subCategoryRules.label">
                      <el-input class="tb-input" maxlength="20" show-word-limit v-model="slot.row.subCategoryName" placeholder="子カテゴリ名称"/>
                    </el-form-item>
                  </el-table-column>
                  <el-table-column cell-class-name="delete-category" v-slot="row">
                    <div class="buttons">
                      <img
                        class="btn btn-remove"
                        @click.stop="clickTagRemove(row.row.id, row.$index)"
                        src="@/assets/icon/sp-icon-delete-new.svg"
                        alt=""
                      />
                    </div>
                  </el-table-column>
                </el-table>
              </el-form>
            </div>
          </div>
          <div class="add-btn">
            <el-button
              v-bind:icon="iconData"
              plain
              class="glance"
              size="small"
              @click="clickTagAdd"
              :class="addAble ? 'disbale_div' : 'able_div'"
            >
            </el-button>
            <div class="button_title">子カテゴリを追加</div>
          </div>

          <div class="text-align">
            <sp-smart-button
              @click="clickDone"
              slot="reference"
              class="create-button"
              >
              {{ $t("button.common.data.create") }}
            </sp-smart-button>
            <cancel-narrow-down class="m-top-3 link-primary" @click="clickCancel">
              {{ $t("button.common.cancel") }}
            </cancel-narrow-down>
          </div>

        </div>
      </div>

    </el-dialog>
    <loading-dialog :dialogVisible="showLoading" />
  </div>
</template>

<script>
import SystemManageApi from "@/api/SystemManageApi"
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import { nextId } from "@/views/visual-env/utils";
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown";
import SpSmartButton from "@/components/common/sp-smart-button"

const MAX_TAG_COUNT = 26;

export default {
  components: {
    LoadingDialog,
    cancelNarrowDown,
    SpSmartButton
  },
  name: "InquiryCategoryPopup",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    buildId: {
      type: String,
      default: null
    },
    categoryId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      title: "お問い合わせカテゴリ作成",
      iconData: "el-icon-circle-plus",
      dialogVisible: false,
      showLoading: false,
      category: {
        ownerId: null,
        ownerName: null,
        ownerExId: null,
        buildingId: null,
        buildingName: null,
        buildingExId: null,
        categoryId: null,
        categoryName: '',
        subCategoryList: [
          {
            subCategoryId: nextId(),
            subCategoryName: ''
          }
        ]
      },
      categoryRules: {
        categoryName: [
          {
            required: true,
            message: "カテゴリ名は必須項目です。",
            trigger: ["blur", "change"]
          },
          {
            max: 20,
            message: "カテゴリ名は20文字以下でご入力ください。",
            trigger: ["blur", "change"]
          }
        ]
      },
      subCategoryRules: {
        label: [
          {
            required: true,
            message: "子カテゴリ名は必須項目です。",
            trigger: ["blur", "change"]
          },
          {
            max: 20,
            message: "子カテゴリ名は20文字以下でご入力ください。",
            trigger: ["blur", "change"]
          }
        ]
      }
    }
  },
  computed: {
    addAble() {
      if (this.category.subCategoryList.length < MAX_TAG_COUNT) {
        return false
      } else {
        return true
      }
    },
    haveScroll(){
      if (this.category.subCategoryList.length > 2) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
      if (this.dialogVisible) {
        this.loadInfo()
      }
    }
  },
  methods: {
    scrollToBottom() {
      const container = this.$refs.scrollContainer;
      container.scrollTop = container.scrollHeight;
    },
    clickDone() {
      Promise.all([this.$refs.categoryForm.validate(), this.$refs.subCategoryFrom.validate()])
        .then(() => {
          if (this.category.categoryId) {
            this.doneUpdate();
          } else {
            this.doneCreate();
          }
        })
    },

    clickCancel() {
      this.category = {
        ownerId: null,
        ownerName: null,
        ownerExId: null,
        buildingId: null,
        buildingName: null,
        buildingExId: null,
        categoryId: null,
        categoryName: '',
        subCategoryList: [
          {
            subCategoryId: nextId(),
            subCategoryName: ''
          }
        ]
      }
      this.dialogVisible = false
      this.$emit('update:visible', false)
      this.$emit('editCategory')
    },
    clickTagAdd() {

      if (this.category.subCategoryList.length < MAX_TAG_COUNT) {
        this.category.subCategoryList.push({
          name: ''
        });
      }

      this.$nextTick(() => {
        this.scrollToBottom();
      })
    },

    clickTagRemove(typeId, index) {
      if (this.category.subCategoryList.length > 1) {
        this.category.subCategoryList.splice(index, 1);
      }
    },
    loadInfo () {
      this.category.buildingId = this.buildId;
      this.category.categoryId = this.categoryId;
      if (this.category.categoryId) {
        this.title = "お問い合わせカテゴリ編集"
        this.showLoading = true;
        SystemManageApi.getInquiryCategory(this.category.categoryId)
          .then(({data}) => {
            if (!statusErrorCodeMsg(data.statusCode, this)) {
              return;
            }
            this.category.categoryId   = data.body.categoryId;
            this.category.categoryName = data.body.categoryName;
            this.category.subCategoryList = data.body.subCategoryList.map(t => ({
              subCategoryId   : t.subCategoryId,
              subCategoryName : t.subCategoryName
            }));
          })
          .catch((error) => {
            errorCodeMsg(error, this)
          })
          .finally(() => {
            this.showLoading = false;
          });
      }else{
        this.title = "お問い合わせカテゴリ作成"
      }

    },

    doneUpdate() {
      this.showLoading = true;
      SystemManageApi.updateInquiryCategory(this.category.categoryId, {
        categoryName: this.category.categoryName,
        subCategoryList: this.category.subCategoryList.map((tag) => ({
          subCategoryId:  this.$IsNullOrEmpty(tag.subCategoryId) ? '' : tag.subCategoryId ,
          categoryName: tag.subCategoryName,
        }))
      }).then(({ data }) => {
        if (!statusErrorCodeMsg(data.statusCode, this)) {
          return;
        }
        this.$messageIotSuccess(this.$t("message.common.updateSuccess", { field: '問合せカテゴリ' }));
        this.clickCancel();
      }).catch((error) => {
        errorCodeMsg(error, this)
      }).finally(() => {
        this.showLoading = false;
      });
    },

    doneCreate() {
      this.showLoading = true;
      var subCategoryList = []
      for (const subCategory of this.category.subCategoryList) {
        subCategoryList.push(subCategory.subCategoryName)
      }

      SystemManageApi.createInquiryCategory({
        buildingId: this.category.buildingId,
        categoryName: this.category.categoryName,
        subCategoryList: subCategoryList
      }).then(({ data }) => {
        if (!statusErrorCodeMsg(data.statusCode, this)) {
          return;
        }
        this.$messageIotSuccess(this.$t("message.common.createSuccess", { field: '問合せカテゴリ' }));
        this.clickCancel();
      }).catch((error) => {
        errorCodeMsg(error, this)
      }).finally(() => {
        this.showLoading = false;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .category-dialog .el-dialog {
  width: 812px;
  height: 645px;
  background: #F2F2ED;
  box-shadow: 3px 3px 12px rgba(6, 7, 8, 0.25);
  border-radius: 6px !important;
  padding: 40px !important;
  .el-dialog__header {
    display: none;
  }
}
::v-deep .category-fin-dialog .el-dialog {
  width: 737px;
  height: 343px;
  background: #F2F2ED;
  box-shadow: 3px 3px 12px rgba(6, 7, 8, 0.25);
  border-radius: 6px !important;
  padding: 40px !important;
  .el-dialog__header {
    display: none;
  }
}
.category-dialog-main-title {
  font-family: Hiragino Kaku Gothic Pro;;
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  line-height: 24px;
  color: #525250;
  margin-bottom: 40px;
}
.category-dialog-sub-title {
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  color: #525250;
}
.category-dialog-tips-title {
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #525250;
}
.category-input-box {
  display: flex;
  align-items: center;
  margin-right: 40px;
  margin-left: -8px;
}
.category-input-text {
  width: 20px;
  text-align: right;
  margin-right: 12px;
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 36px;
  color: #525250;
}
.category-input {
  width: 324px;
}
::v-deep .category-input .el-input__inner {
  background: #F7F7F2;
  width: 324px;
  box-shadow: inset 3px 3px 3px #DEDED1, inset -3px -3px 4px #FFFFFA;
  border-radius: 8px;
  font-family: 'Hiragino Kaku Gothic ProN', sans-serif !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #000000 !important;
}
.category-dialog-form .el-form {
  display: flex;
  flex-wrap: wrap;
  height: 356px;
  flex-direction: column;
}
.category-dialog-form .el-form-item {
  margin-bottom: 30px !important;
}
.category-dialog-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.category-dialog-create {
  margin-left: 0;
  margin-right: 0;
  margin-top: 6px;
  padding: 10px;
  gap: 10px;
  width: 296px;
  height: 40px;
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: #FFFFFF;
  background: #329CA6;
  border: none;
  box-shadow: -4px -4px 5px #FFFFFF, 3px 3px 6px #B8B8AD;
  border-radius: 8px;
}
.category-dialog-create:hover {
  opacity: 0.8;
}
.category-dialog-create:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.category-dialog-cancel {
  margin-left: 0;
  margin-right: 0;
  margin-top: 20px;
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 11px;
  color: #329CA6;
  border: none;
  background: none;
}
.category-dialog-cancel:hover {
  opacity: 0.8;
}
.category-dialog-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
::v-deep .category-dialog-form .el-form-item__error {
  margin-left: 26px;
  width: 324px;
}
.category-input::placeholder {
  font-family: 'Hiragino Kaku Gothic ProN', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #B8B8B3;
}
.text-align-center {
  text-align: center;
}
.glance {
  border: 0px;
  text-align: left;
  padding: 0;
  border-radius: 50% !important;
  color: #329ca6;
  background-color: transparent;
  font-weight: bold;
  width: 18px;
  height: 18px;
  font-size: 14px;
  box-shadow: -2px -2px 5px #FCFCFB,
               5px  5px 8px #C6C6BC;
  display: flex;
}
.glance:hover {
  opacity: 0.6;
}
.glance:focus {
  color: #329ca6;
  background-color: transparent;
}
// 設定icon大小
::v-deep .el-icon-circle-plus:before {
  font-size: 23px;
}
::v-deep .el-icon-remove:before {
  font-size: 23px;
}
.button_title {
  color: #525250;
  font-weight: 600;
  font-size: 14px;
  padding-left: 8px;
}
.add-btn {
  display: flex;
  margin-left: 124px;
  margin-top: 24px;
}
.sub-category-list-no-scroll {
  width: 80%;
  height: 200px;
}
.sub-category-list {
  width: 80%;
  height: 200px;
  overflow-y: scroll;
}
.text-align {
  text-align: center;
}
.create-button {
  margin-top: 50px;
  height: 40px;
  width: 296px;
  background-color: #329ca6;
  color: rgba(255, 255, 255, 1);
}
.table-sub-category {
  ::v-deep .el-table_2_column_5  .cell {
    margin-top: -20px;
  }
}

.category-info {
  ::v-deep .el-form-item__content {

  }
}

::v-deep .el-table td {
  border: none !important;
  padding: 0;
}

::v-deep .el-table__header {
  border-bottom: none !important;
}

.disbale_div {
  cursor: not-allowed;
}

::v-deep .el-table .has-gutter {
  display: none;
}

.hr-delimiter {
  margin-top: 40px;
  margin-bottom: 40px;
}

::v-deep.el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before {
  content: "";
  display: none;
}

.master-start {
  width: 1000px;
}

::v-deep .master-start > .el-form-item__label::after {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.must_star{
  color: #f56c6c;
}
</style>
